module.exports = __webpack_public_path__ + "img/medal.8e39aeb5.svg";